<template>
	<div>

		<div class="z-20 absolute top-0 lg:h-screen lg:overflow-y-auto ">
			<ConfirmModal v-if="showConfirmModal" @confirm="signout()" @cancel="closeModal()"
				message='Press confirm to sign out' />
			<nav class="fixed lg:h-full lg:w-[250px] w-full flex-shrink-0 ">

				<div class="h-14 pl-3 pr-6 w-full bg-white shadow-lg flex justify-between items-center">
					<!-- boogi logo -->
					<div @click="$router.push('/')" class="z-30 cursor-pointer lg:pt-2 flex px-2">
						<img src="../../assets/boogi-logo-gray-800.svg" class="h-[28px]">
					</div>

					<!-- dropdown icons -->
					<div @click="expandDropdown" :class="showLinks ? 'rotate-90' : ''"
						class="curspor-pointer lg:hidden transition-transform duration-200 transform flex h-full items-center justify-center w-6 h-6 absolute right-4">

						<!-- hamburger -->
						<svg :class="showLinks ? 'opacity-0' : 'opacity-100'"
							class="h-6 w-6 text-gray-800 cursor-pointer absolute transition-opacity duration-200"
							xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
								d="M4 6h16M4 12h16M4 18h16" />
						</svg>

						<!-- cross -->
						<svg xmlns="http://www.w3.org/2000/svg" :class="showLinks ? 'opacity-100' : 'opacity-0'"
							class="h-6 w-6 text-gray-800 cursor-pointer absolute transition-opacity duration-200"
							fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
							<path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
						</svg>
					</div>
				</div>

				<div :class="showLinks ? 'scale-y-100 translate-y-0' : 'scale-y-0 -translate-y-1/2'"
					class="bg-white w-full transform transition-all duration-200 absolute rounded-b-xl lg:rounded-b-none pb-1 lg:pb-0 lg:relative lg:transform-none lg:transition-none lg:h-full z-30">
					<div>
						<div class="pt-2">
							<NavLink text="Home" icon="Home" link="/launchpad" />
							<NavSectionHeader text="Cashback program" />
							<NavLink text="Program offers" icon="BadgePercent" link="/program-offers" />
							<NavLink text="Cashback ledger" icon="BookOpenText" link="/cashback-ledger" />
							<NavLink text="Payouts" icon="BadgePoundSterling" link="/payouts" />

							<NavSectionHeader text="Retailers" />
							<NavLink text="Retailer catalogue" icon="Store" link="/retailer-catalogue" />
							<NavLink text="Offer approvals" icon="ListTodo" link="/retailer-approvals" />

							<NavSectionHeader text="Monitoring" />
							<NavLink text="Transaction enrichment" icon="Sparkles" link="/transaction-enrichment" />
							<NavLink text="Bank connections" icon="Landmark" link="/bank-connections" />
							<NavLink text="Billing" icon="ReceiptText" link="/billing" />

							<NavSectionHeader text="Integration" />
							<NavLink text="Playground" icon="Play" link="/playground" />
							<NavLink text="API Keys" icon="KeySquare" link="/api-keys" />
							<NavLink text="Webhooks" icon="Webhook" link="/webhooks" />
							<NavSectionHeader text="Support" />
							<a class="" link="/docs" href="https://app.theneo.io/boogi/boogi-cashback-apis/" target=”_blank”>
								<div class="pr-2 mb-[3px]">
									<div id="launchpadButton" class="flex pl-4 h-[32px] w-full hover:bg-gray-200 rounded-r-md cursor-pointer">
										<LucideIcon name="ExternalLink" :size="20" :stroke-width="1.8" color="#20283A" class="self-center" />
										<p class="text-[15px] pt-[3px] text-gray-800 font-medium w-auto pl-3 whitespace-wrap self-center">
											Documentation
										</p>
									</div>
								</div>
							</a>
							<!--<a class="" link="/docs" href="https://insigh.to/b/boogi-feature-requests" target=”_blank”>
								<div class="pr-2 mb-[3px]">
									<div id="launchpadButton" class="flex pl-4 h-[32px] w-full hover:bg-gray-200 rounded-r-md cursor-pointer">
										<LucideIcon name="MessageSquarePlus" :size="20" :stroke-width="1.8" color="#20283A" class="self-center" />
										<p class="text-[15px] pt-[3px] text-gray-800 font-medium w-auto pl-3 whitespace-wrap self-center">
											Request a feature
										</p>
									</div>
								</div>
							</a>-->
							<a class="" link="/docs" href="https://share-eu1.hsforms.com/1jg0wAXzgQw-KJXQ6Efv2rA2dkrat" target=”_blank”>
								<div class="pr-2 mb-[3px]">
									<div id="launchpadButton" class="flex pl-4 h-[32px] w-full hover:bg-gray-200 rounded-r-md cursor-pointer">
										<LucideIcon name="TriangleAlert" :size="20" :stroke-width="1.8" color="#20283A" class="self-center" />
										<p class="text-[15px] pt-[3px] text-gray-800 font-medium w-auto pl-3 whitespace-wrap self-center">
											Report an issue
										</p>
									</div>
								</div>
							</a>
						</div>
					</div>
				</div>
			</nav>
		</div>
	</div>
</template>

<script>
import ConfirmModal from '@/components/modals/ConfirmModal';
import NavLink from '@/components/navbars/NavLink';
import NavSectionHeader from '@/components/navbars/NavSectionHeader';
import { DateTime } from 'luxon';
import LucideIcon from "@/components/LucideIcon.vue";

export default {
	name: "SideBar",
	components: {
		ConfirmModal,
		NavLink,
		NavSectionHeader,
		LucideIcon,
	},
	data() {
		return {
			openDropdown: '',
			showLinks: false,
			showConfirmModal: false,
			//			subscriptionStatus: null,
			//			billingDashboardUrl: '',
			loading: false,
			//			showUpgradeModal: false,
			credits: undefined,
			loyaltyOpen: false,
			marketingOpen: false,
			caOpen: false,
			rewardemailOpen: false,
		}
	},
	methods: {

		niceDateTime(dateObject) {
			return DateTime.fromISO(dateObject, { setZone: true }).toLocaleString(DateTime.DATE_MED)
		},
		daysRemaining(dateObject) {
			const date1 = DateTime.fromISO(dateObject, { setZone: true })
			const date2 = DateTime.now()
			this.diff = date1.diff(date2, ["years", "months", "days", "hours"])
			var x = this.diff.toObject()
			return x.days
		},

		closeModal() {
			this.showConfirmModal = false;
		},
		handleSignOutConfirm() {
			this.showConfirmModal = true;
		},
		navigateToHelp() {
		},
		handleExpand(value) {
			if (value == 'marketing') { this.$router.push('/automated-marketing').catch(() => { }) }
			if (value == 'communication') { this.$router.push('/customer-acquisition').catch(() => { }) }
			if (value == 'listing') {
				{ this.$router.push('/listings').catch(() => { }) }
			}
			if (value == 'customers') {
				{ this.$router.push('/customers').catch(() => { }) }
			}
			if (value == 'venue') {
				{ this.$router.push('/venue').catch(() => { }) }
			}
			if (value == 'offersAndBrand') {
				{ this.$router.push('/offers-and-brand-deals').catch(() => { }) }
			}
			this.openDropdown = value;
		},
		expandDropdown() {
			if (this.showLinks === true) this.handleExpand('');
			this.showLinks = !this.showLinks
		},
		signout() {

		},
	},
	computed: {


	},

}
</script>

<style scoped>
.router-link-active {
	background-color: #e5e7eb
}
</style>